/**
 * DaVinci Selection Utility
 * 
 * Wraps browser Selection API to provide stable range handling for the Rich Text Editor.
 * Helps with:
 * 1. Saving/Restoring cursor position (crucial for contenteditable)
 * 2. Applying formatting commands safely
 */

export const DaVinciSelection = {
    /**
     * Returns the current selection ragne if it is inside the specified container.
     * @param {HTMLElement} container 
     * @returns {Range|null}
     */
    getRange(container) {
        const selection = window.getSelection();
        if (selection.rangeCount === 0) return null;

        const range = selection.getRangeAt(0);

        // Check if selection is within container
        if (container.contains(range.commonAncestorContainer)) {
            return range;
        }
        return null;
    },

    /**
     * Restores a previously saved range.
     * @param {Range} range 
     */
    restoreRange(range) {
        if (!range) return;
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
    },

    /**
     * Executes a standard execCommand for styling (Bold, Italic).
     * Note: execCommand is deprecated but still the most reliable way for simple styling
     * without a huge engine. For color, we might need custom logic.
     * @param {string} command - 'bold', 'italic', etc.
     * @param {string} value - Argument for command (e.g. color hex)
     */
    applyStyle(command, value = null) {
        // [FIX] Prefer CSS styles (<span style="color:...">) over legacy HTML attributes (<font color="...">)
        // However, we enabled <font> in Sanitizer just in case.
        if (typeof document.execCommand === 'function') {
            try {
                document.execCommand('styleWithCSS', false, true);
            } catch (e) {
                // Ignore failure
            }
            document.execCommand(command, false, value);
        }
    },

    /**
     * Checks if functionality is supported
     */
    isSupported() {
        return typeof document.execCommand === 'function';
    }
};
